import { z } from 'zod';
import { shared } from '@tig-dpqa-cloud/contract-backend-common';

export const dataplaneVersionsResponse = z.array(z.string()).default([]);

export const dataplaneResponse = z.object({
  id: shared.DataplaneId,
  revoked: z.boolean(),
  revokedAt: z.string().datetime({ offset: true }).optional(),
  lastPingedAt: z.string().datetime({ offset: true }).optional(),
  certificateExpiresAt: z.string().datetime({ offset: true }).optional(),
  version: z.string(),
  tenantId: shared.TenantId,
});

export const dataplaneListResponse = z.array(
  dataplaneResponse,
);

export const DataplaneRequestQueryPath = z.object({
  dataplaneId: shared.DataplaneId,
});

export type DataplaneVersionsType = z.infer<typeof dataplaneVersionsResponse>;

export type DataplaneType = z.infer<typeof dataplaneResponse>;

export type DataplaneListType = z.infer<typeof dataplaneListResponse>;

export type DataplaneRequestQueryPathType = z.infer<typeof DataplaneRequestQueryPath>;
